export default {"src":"/_next/static/media/hostel.00551982.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};